import {
  MbDialog,
  MbBasicDialog,
  MbDialogHeader,
  MbDialogBody,
  MbRadioGroup,
  MbRadioButton,
  MbButton,
  MbIcon,
  MbDialogFooter,
} from '@am/moebius';
import { Component, Input, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { AnalyticsService } from '@core/services/analytics.service';
import { select, Store } from '@ngrx/store';
import { toggleFilter } from '@results/store/results.actions';
// import { ToggleFilter } from '@results/store/results.actions';
import { IHotelsAppState } from '@store/index';
import { selectOrderByQueryParam } from '@store/router/router.selector';

@Component({
  selector: 'am-sorting-by-mobile',
  styleUrls: ['./sorting-by-mobile.component.scss'],
  templateUrl: './sorting-by-mobile.component.html',
  imports: [
    MbBasicDialog,
    MbDialogHeader,
    MbDialogBody,
    MbDialogFooter,
    MbRadioGroup,
    MbRadioButton,
    MbButton,
    MbIcon,
  ],
})
export class SortingByMobileComponent implements OnInit {
  @Input()
  public loading: any;
  @Input()
  public disabled: any;
  @ViewChild('sortingDialog', { static: true })
  private sortingDialog: TemplateRef<any>;

  public storedSortingValue: any;
  public sortingValue: any;

  constructor(
    private vcr: ViewContainerRef,
    private dialog: MbDialog,
    private store$: Store<IHotelsAppState>,
    private analyticsService: AnalyticsService,
  ) {}

  public ngOnInit() {
    this.store$.pipe(select(selectOrderByQueryParam)).subscribe((orderBy) => {
      this.storedSortingValue = orderBy.sortBy
        ? `${orderBy.sortBy}-${orderBy.sortCriteria}`
        : 'recommended';
      this.sortingValue = this.storedSortingValue;
    });
  }

  public togglesOpenDialog() {
    this.dialog.open(this.sortingDialog, {
      closeOnBackdropClick: true,
      closeOnEscKey: true,
      viewContainerRef: this.vcr,
    });
  }

  public applyChange(dialogRef: any) {
    this.trackSorting(this.sortingValue);
    const sortArray = this.sortingValue !== 'recommended' ? this.sortingValue.split('-') : [];
    const newSortingData = {
      sortBy: sortArray[0],
      sortCriteria: sortArray[1],
    };
    this.store$.dispatch(toggleFilter({ payload: newSortingData }));
    dialogRef.close();
  }

  private trackSorting(sortType) {
    const map = {
      ASC: 'Lowest',
      DESC: 'Highest',
      price: 'Price',
      rating: 'Score Review',
      recommended: 'Recommended',
      stars: 'Stars',
    };
    const splitValue = sortType.split('-');
    this.analyticsService.trackEvent({
      action: 'Sort',
      label:
        map[splitValue[0]] + '|' + (map[splitValue[1]] ? map[splitValue[1]] : map[splitValue[0]]),
      section: 'Results',
    });
  }
}
